// @cosbeni/core の最小 vendored 版 (active-promotion.app 用)。
// lib/auth・lib/database が使う type() ユーティリティと LogService だけを提供する。
// (元 lib: code/cosbeni/cosbeni.core.app — Angular 19 版が無いためアプリ内に取り込み)
import {Injectable, ModuleWithProviders, NgModule} from '@angular/core';

const typeCache: { [label: string]: boolean } = {};

// ngrx action type の一意性を保証する (元実装と同じ)
export function type<T>(label: T | ''): T {
  if (typeCache[label as string]) {
    throw new Error(`Action type "${label}" is not unique"`);
  }
  typeCache[label as string] = true;
  return label as T;
}

@Injectable({providedIn: 'root'})
export class LogService {
  public debug(...msg: unknown[]): void {
    console.debug(...msg);
  }

  public error(...msg: unknown[]): void {
    console.error(...msg);
  }

  public inspect(...msg: unknown[]): void {
    console.log(...msg);
  }
}

@NgModule({})
export class CoreModule {
  static forRoot(providers: unknown[] = []): ModuleWithProviders<CoreModule> {
    return {ngModule: CoreModule, providers: providers as never[]};
  }
}
